import { render, staticRenderFns } from "./FormatList.vue?vue&type=template&id=ce5c094e&scoped=true"
import script from "./FormatList.vue?vue&type=script&lang=js"
export * from "./FormatList.vue?vue&type=script&lang=js"
import style0 from "./FormatList.vue?vue&type=style&index=0&id=ce5c094e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5c094e",
  null
  
)

export default component.exports